/**
 * Reusable tweet header.
 *
 * Modes (layout only — markup stays shared):
 *   compact  — timeline scan line: Username · time
 *   expanded — detail identity block:
 *                row 1: Username                    Timestamp
 *                row 2: Public key
 *   compose  — stacked name + instructional secondary (compose overlay)
 *
 * Callers should not need to know layout internals.
 */
function resolveMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    mode = _ref.mode,
    presentation = _ref.presentation;
  if (mode === 'compact' || mode === 'expanded' || mode === 'compose') {
    return mode;
  }
  if (presentation === 'focused') {
    return 'expanded';
  }
  if (presentation === 'compose') {
    return 'compose';
  }
  return 'compact';
}
function escapeHtml() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
module.exports = function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    mode = _ref2.mode,
    presentation = _ref2.presentation,
    _ref2$publicKey = _ref2.publicKey,
    publicKey = _ref2$publicKey === void 0 ? '' : _ref2$publicKey,
    _ref2$name = _ref2.name,
    name = _ref2$name === void 0 ? '' : _ref2$name,
    _ref2$handle = _ref2.handle,
    handle = _ref2$handle === void 0 ? '' : _ref2$handle,
    _ref2$time = _ref2.time,
    time = _ref2$time === void 0 ? '' : _ref2$time,
    _ref2$secondary = _ref2.secondary,
    secondary = _ref2$secondary === void 0 ? '' : _ref2$secondary;
  var resolvedMode = resolveMode({
    mode: mode,
    presentation: presentation
  });
  if (resolvedMode === 'compose') {
    var secondaryHtml = secondary ? "<span class=\"secondary saito-userline\">".concat(escapeHtml(secondary), "</span>") : '';
    return "\n    <header class=\"header compose\">\n      <span class=\"primary saito-address\" data-id=\"".concat(escapeHtml(publicKey), "\">").concat(escapeHtml(name), "</span>\n      ").concat(secondaryHtml, "\n    </header>\n  ");
  }
  if (resolvedMode === 'expanded') {
    var timeHtml = time ? "<time class=\"time saito-userline\">".concat(escapeHtml(time), "</time>") : '';
    var handleHtml = handle ? "<span class=\"handle saito-userline saito-add-user-menu\" data-id=\"".concat(escapeHtml(publicKey), "\">").concat(escapeHtml(handle), "</span>") : '';

    // Identity owns name, time, and key. Body is a sibling — never a time host.
    return "\n    <header class=\"header expanded\">\n      <span class=\"primary saito-address\" data-id=\"".concat(escapeHtml(publicKey), "\">").concat(escapeHtml(name), "</span>\n      ").concat(timeHtml, "\n      ").concat(handleHtml, "\n    </header>\n  ");
  }

  // compact — Username · time (no public key on the timeline)
  var parts = [];
  parts.push("<span class=\"primary saito-address\" data-id=\"".concat(escapeHtml(publicKey), "\">").concat(escapeHtml(name), "</span>"));
  if (time) {
    parts.push("<span class=\"sep\" aria-hidden=\"true\">\xB7</span>");
    parts.push("<time class=\"time saito-userline\">".concat(escapeHtml(time), "</time>"));
  }
  return "\n    <header class=\"header compact\">\n      ".concat(parts.join('\n      '), "\n    </header>\n  ");
};
module.exports.resolveMode = resolveMode;